import {MainRequest} from 'Services/common';
import {download, formatDate} from '../../../Utils/common';
import {Tags} from '../service';

export interface GetArticle {
    keyword?: string;
    dateStart?: string; //开始日期
    dateEnd?: string; //结束日期
    tagIds?: string[];
    time?: string[];
}

type QueryArticlePage = GetArticle & Pagination;

export interface ArticleList {
    tags: Tags[]; //
    digest: string; //    摘要
    link: string; //    文章链接
    publishDate: string; //    发布时间
    id: string; //    主键id
    title: string; //    文章标题
    officialAccountName: string; //    所属公众号名称
}

//导出
export function exportArticle(params: GetArticle) {
    return download('/wechatSaas/exportArticle', {
        method: 'get',
        params: {
            ...params,
            tagIds: params?.tagIds?.join(','),
        },
    });
}

//获取列表
export function getArticlePage(params?: QueryArticlePage) {
    if (params?.dateStart) {
        params.dateStart = formatDate(params?.dateStart);
    }
    if (params?.dateEnd) {
        params.dateEnd = formatDate(params?.dateEnd);
    }
    return MainRequest.post<PagedSuccessData<ArticleList[]>>(
        '/wechatSaas/findArticlePage',
        {
            keyword: params?.keyword,
            tagIds: params?.tagIds,
            pageNo: params?.pageNo,
            pageSize: params?.pageSize,
            dateStart: params?.time?.[0],
            dateEnd: params?.time?.[1],
        },
    ).then(res => res.data.data);
}

//删除
export function deleteArticle(id: string) {
    return MainRequest.get(`/wechatSaas/deleteArticle/${id}`);
}

interface SaveTag {
    id: string;
    tagList: string;
}
export function saveArticleTag(data: SaveTag) {
    return MainRequest.post(`/wechatSaas/saveArticle`, data);
}
